<template>
  <div>
    <div
      class="
        w-100
        p-2
        d-flex
        align-items-center
        wc-stage__header
        wc-stage__header-active
      "
    >
      <h2 class="d-inline-block mb-0 font-weight-bold  wc-review-order-header">
        {{ $t('reviewYourItems') }}
      </h2>
      <strong class="float-right wc-review-order-price">{{ totals.sub | currency }}</strong>
    </div>
    <div class="d-flex flex-column m-3">
      <WCMobileCoupons
        :coupons="coupons"
        :lineItems="lineItems"
        :addedCouponValid="addedCouponValid"
        @addcoupon="$emit('addcoupon', $event)"
        @removecoupon="$emit('removecoupon', $event)"
      />
      <h3>
        {{ $t('reviewYourItems') }}
      </h3>

      <WCOutOfStockAlert
        v-if="outofstockLineItems && outofstockLineItems.length > 0"
        :outofstockLineItems="outofstockLineItems"
      />

      <WCCheckoutLineItems
        :lineItems="lineItems"
        :isScanAndGoMode="true"
        @instructions="
          setItemLineItemInstructions($event);
          $emit('set-dirty', true);
        "
        @substitutable="
          setItemLineItemSubstitutable($event);
          $emit('set-dirty', true);
        "
      />
    </div>
    <div class="d-flex justify-content-between my-3 mt-lg-5">
      <button
        :aria-label="$t('goBack')"
        @click="$router.go(-1)"
        class="btn unstyled-btn text-primary w-25 font-weight-bold"
      >
        {{ $t('goBack') }}
      </button>
      <button @click="$emit('checkout')" class="btn btn-primary btn-block w-25 stage-button">
        {{ $t('continue') }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import WCOutOfStockAlert from '@/modules/cart/components/WCOutOfStockAlert/WCOutOfStockAlert.vue';
import WCCheckoutLineItems from '@/modules/checkout/components/WCFinalizeStage/WCCheckoutLineItems/WCCheckoutLineItems.vue';
import WCMobileCoupons from '@/modules/checkout/components/WCMobileCoupons/WCMobileCoupons.vue';
import ModalService from '@/modules/modals/services/modal.service';
import WCConfirmationModal from '@/components/WCConfirmationModal/WCConfirmationModal.vue';

export default {
  name: 'WCReviewCheckoutItem',
  components: {
    WCCheckoutLineItems,
    WCOutOfStockAlert,
    WCMobileCoupons,
  },
  props: {
    lineItems: {
      type: Array,
    },
    outofstockLineItems: {
      type: Array,
    },
    coupons: {
      type: Array,
    },
    addedCouponValid: {
      type: Boolean,
      default: true,
    },
    totals: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.linkedItemsRestricted();
  },
  methods: {
    ...mapActions({
      setItemLineItemInstructions: 'cart/setItemLineItemInstructions',
      setItemLineItemSubstitutable: 'cart/setItemLineItemSubstitutable',
      // setDeferrableCombos: 'cart/setDeferrableCombos',
    }),
    linkedItemsRestricted() {
      let linkedItemsRestricted = false;
      this.lineItems?.forEach(item => {
        item.linkedItems?.forEach(i => {
          if (i.item.hasRestriction) {
            linkedItemsRestricted = true;
          }
        });
      });
      if (linkedItemsRestricted) {
        this.renderLinkedItemRestrictedModal();
      }
    },
    async renderLinkedItemRestrictedModal() {
      try {
        await ModalService.open(WCConfirmationModal, {
          headerIcon: 'ban',
          header: this.$t('itemRestricted'),
          content: this.$t('itemRestrictedCartMsg'),
          cancel: this.$t('okayGotIt'),
        });
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.wc-stage__header-active {
  background-color: var(--secondary-lighter-7, get-color('secondary', 'lighter-7'));
}
.wc-promos-section {
  width: 40%;
}
.stage-button {
  min-width: 33%;
}
.wc-review-order-header {
  flex: 2;
}
.wc-review-order-price {
  flex: 1;
  text-align: right;
  justify-content: center;
}
</style>
